import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RankingResponse } from '../interfaces/RankingResponse.interface';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RankingService {

  constructor
    (public http: HttpClient,
      private readonly sessionService: SessionStorageService
    ) { }

  getRanking(raceId: string, onlyFinisher: boolean = false, eventId: string): Observable<RankingResponse> {
    return this.http.get<RankingResponse>(`${environment.apiUrl}/event/${eventId}/race/${raceId}/ranking`, { params: { onlyFinisher } });
  }

  postRanking(raceId: string): Observable<RankingResponse> {
    return this.http.post<RankingResponse>(`${environment.apiUrl}/ranking/race/${raceId}`, null, { headers: { 'Authorization': `Bearer ${this.sessionService.token}` } })
  }

  getRankingAnim(raceId: string): Observable<RankingResponse> {
    return this.http.get<RankingResponse>(`${environment.apiUrl}/race/${raceId}/timing/stats`, { headers: { 'Authorization': `Bearer ${this.sessionService.token}` } });
  }
}
